// extracted by mini-css-extract-plugin
export default {"checkboxwrapper":"Checkbox_checkboxwrapper__7X56x"};